// Stable entry point establishes the Windows App Installer update association.
export const WINDOWS_INSTALLER_URL = "https://www.signaltuner.com/downloads/windows/SignalTuner.appinstaller";
